import { useEffect } from 'react';

import { TimesIcon } from '../../assets/svg';
import { useFloatingAlert } from '../../hooks/useFloatingAlert';
import { useMerchant } from '../../hooks/useMerchant';
import { AlertContainer, AlertMessage, AlertWrapper, CloseButton } from './styles';

const FloatingAlert = () => {
	const { merchantSelected } = useMerchant();
	const { show, type, message, handleCloseAlert } = useFloatingAlert();

	useEffect(() => {
		handleCloseAlert()
	}, [merchantSelected])
	
	return (
		<AlertContainer show={show}>
			<AlertWrapper type={type}>
				<AlertMessage>{message}</AlertMessage>
				<CloseButton onClick={handleCloseAlert}>
					<TimesIcon />
				</CloseButton>
			</AlertWrapper>
		</AlertContainer>
	);
};

export { FloatingAlert };
